import { createSlice } from '@reduxjs/toolkit'

const {
  actions: {
    getAllAffiliatesStart,
    getAllAffiliatesSuccess,
    getAllAffiliatesFailure,
    getAllCmsStart,
    getAllCmsSuccess,
    getAllCmsFailure,
    getAllPromotionsStart,
    getAllPromotionsSuccess,
    getAllPromotionsFailure,
    deletePromotionsStart,
    deletePromotionsSuccess,
    deletePromotionsFailure,
    clearAllCms,
    getAllAvatarsSuccess,
    getAllAvatarsFailure,
    clearAllAvatars,
    getAllUsersStart,
    getAllUsersSuccess,
    getAllUsersFailure,
    clearAllUsers,
    getUserStart,
    getUserSuccess,
    getUserFailure,
    getAffiliateByIdStart,
    getAffiliateByIdSuccess,
    getAffiliateByIdFailure,
    getCmsByPageIdStart,
    getCmsByPageIdSuccess,
    getCmsByPageIdFailure,
    getCountriesStart,
    getCountriesSuccess,
    getCountriesFailure,
    getTenantCountriesStart,
    getTenantCountriesSuccess,
    getTenantCountriesFailure,
    getRestrictedItemsStart,
    getRestrictedItemsSuccess,
    getRestrictedItemsFailure,
    getUnRestrictedItemsStart,
    getUnRestrictedItemsSuccess,
    getUnRestrictedItemsFailure,
    addRestrictedItemsStart,
    addRestrictedItemsComplete,
    deleteRestrictedItemsStart,
    deleteRestrictedItemsComplete,
    resetRestrictedItemsStart,
    resetRestrictedItemsComplete,
    getRestrictedCountriesStart,
    getRestrictedCountriesSuccess,
    getRestrictedCountriesFailure,
    getUnRestrictedCountriesStart,
    getUnRestrictedCountriesSuccess,
    getUnRestrictedCountriesFailure,
    addRestrictedCountriesStart,
    addRestrictedCountriesComplete,
    deleteRestrictedCountriesStart,
    deleteRestrictedCountriesComplete,
    resetRestrictedCountriesStart,
    resetRestrictedCountriesComplete,
    updateSuperAdminCMSStart,
    updateSuperAdminCMSComplete,
    updatePromotionsStart,
    updatePromotionsComplete,
    getGlobalRegistrationStart,
    getGlobalRegistrationCompleted,
    getGlobalRegistrationFailed,
    updateGlobalRegistrationStart,
    updateGlobalRegistrationCompleted,
    updateGlobalRegistrationFailed,
    getSAUserDocumentStart,
    getUserDocumentSuccess,
    getUserDocumentFailure,
    verifyUserDocumentStart,
    verifyUserDocumentComplete,
    updateSACMSStatusStart,
    updateSACMSStatusComplete,
    getCMSDynamicKeysStart,
    getCMSDynamicKeysSuccess,
    getCMSDynamicKeysFailure,
    deleteCMSLanguageStart,
    deleteCMSLanguageComplete,
    updateKycMethodStart,
    updateKycMethodComplete,
    updateCountryStatusStart,
    updateCountryStatusComplete,
    addReviewFailure,
    addReviewSuccess,
    addReviewStart,
    getReviewByIdFailure,
    getReviewByIdSuccess,
    getReviewByIdStart,
    updateReviewFailure,
    updateReviewSuccess,
    updateReviewStart,
    getAllReviewFailure,
    getAllReviewSuccess,
    getAllReviewStart,
    deleteCMSStart,
    deleteCMSSuccess,
    deleteCMSFailure,

    deleteUserStart,
    deleteUserSuccess,
    deleteUserFailure,

    restoreUserStart,
restoreUserSuccess,
restoreUserFailure,

  },
  reducer
} = createSlice({
  name: 'fetchData',
  initialState: {
    loading: false,
    error: null,
    success: false,
    affiliatesData: null,
    cmsData: null,
    userData: null,
    avatarData: null,
    affiliateByIdData: null,
    cmsByPageIdData: null,
    countries: null,
    tenantCountries: null,
    restrictedItems: null,
    unRestrictedItems: null,
    restrictedCountries: null,
    unRestrictedCountries: null,
    userDocuments: null,
    keysLoading: false,
    cmsKeys: null,
    reviewList: null,
    reviewDetail: null,
    promotionsData: null,
    CMSDeleteData: null,
    userDeleteSuccess: false,
    restoreUserSuccess: null
  },
  reducers: {
    getAllAffiliatesStart: (state) => ({
      ...state,
      loading: true
    }),
    getAllAffiliatesSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      affiliatesData: payload
    }),
    getAllAffiliatesFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    getAffiliateByIdStart: (state) => ({
      ...state,
      loading: true
    }),
    getAffiliateByIdSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      affiliateByIdData: payload
    }),
    getAffiliateByIdFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    getAllCmsStart: (state) => ({
      ...state,
      loading: true
    }),
    getAllCmsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      cmsData: payload
    }),
    getAllCmsFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    getAllPromotionsStart: (state) => ({
      ...state,
      loading: true
    }),
    getAllPromotionsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      promotionsData: payload
    }),
    getAllPromotionsFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    deletePromotionsStart: (state) => ({
      ...state,
      loading: true
    }),
    deletePromotionsSuccess: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
    }),
    deletePromotionsFailure: (state) => ({
      ...state,
      loading: false,
      success: false
    }),
    clearAllCms: (state) => ({
      ...state,
      cmsData: null
    }),
    getCmsByPageIdStart: (state) => ({
      ...state,
      cmsByPageIdData: null,
      loading: true
    }),
    getCmsByPageIdSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      cmsByPageIdData: payload
    }),
    getCmsByPageIdFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    getAllAvatarsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      avatarData: payload
    }),
    getAllAvatarsFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    clearAllAvatars: (state) => ({
      ...state,
      userData: null
    }),
    getAllUsersStart: (state) => ({
      ...state,
      loading: true
    }),
    getAllUsersSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      userData: payload
    }),
    getAllUsersFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    clearAllUsers: (state) => ({
      ...state,
      userData: null
    }),
    getUserStart: (state, { payload }) => (
      {
        ...state,
        userData: null,
        loading: true,
        payload
      }
    ),
    getUserSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      userData: payload
    }),
    getUserFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload,
      success: false
    }),
    getCountriesStart: (state) => ({
      ...state,
      loading: true
    }),
    getCountriesSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      countries: payload
    }),
    getCountriesFailure: (state) => ({
      ...state,
      loading: false
    }),
    getTenantCountriesStart: (state) => ({
      ...state,
      loading: true
    }),
    getTenantCountriesSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      tenantCountries: payload
    }),
    getTenantCountriesFailure: (state) => ({
      ...state,
      loading: false
    }),
    getRestrictedItemsStart: (state) => ({
      ...state,
      loading: true
    }),
    getRestrictedItemsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      restrictedItems: payload
    }),
    getRestrictedItemsFailure: (state) => ({
      ...state,
      loading: false
    }),
    getUnRestrictedItemsStart: (state) => ({
      ...state,
      loading: true
    }),
    getUnRestrictedItemsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      unRestrictedItems: payload
    }),
    getUnRestrictedItemsFailure: (state) => ({
      ...state,
      loading: false
    }),
    addRestrictedItemsStart: (state) => ({
      ...state,
      loading: true
    }),
    addRestrictedItemsComplete: (state) => ({
      ...state,
      loading: false
    }),
    deleteRestrictedItemsStart: (state) => ({
      ...state,
      loading: true
    }),
    deleteRestrictedItemsComplete: (state) => ({
      ...state,
      loading: false
    }),
    resetRestrictedItemsStart: (state) => ({
      ...state
    }),
    resetRestrictedItemsComplete: (state) => ({
      ...state,
      restrictedItems: null,
      unRestrictedItems: null
    }),
    getRestrictedCountriesStart: (state) => ({
      ...state,
      loading: true
    }),
    getRestrictedCountriesSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      restrictedCountries: payload
    }),
    getRestrictedCountriesFailure: (state) => ({
      ...state,
      loading: false
    }),
    getUnRestrictedCountriesStart: (state) => ({
      ...state,
      loading: true
    }),
    getUnRestrictedCountriesSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      unRestrictedCountries: payload
    }),
    getUnRestrictedCountriesFailure: (state) => ({
      ...state,
      loading: false
    }),
    addRestrictedCountriesStart: (state) => ({
      ...state,
      loading: true
    }),
    addRestrictedCountriesComplete: (state) => ({
      ...state,
      loading: false
    }),
    deleteRestrictedCountriesStart: (state) => ({
      ...state,
      loading: true
    }),
    deleteRestrictedCountriesComplete: (state) => ({
      ...state,
      loading: false
    }),
    resetRestrictedCountriesStart: (state) => ({
      ...state
    }),
    resetRestrictedCountriesComplete: (state) => ({
      ...state,
      restrictedCountries: null,
      unRestrictedCountries: null
    }),
    updateSuperAdminCMSStart: (state) => ({
      ...state,
      loading: true
    }),
    updateSuperAdminCMSComplete: (state) => ({
      ...state,
      loading: false
    }),
    updatePromotionsStart: (state) => ({
      ...state,
      loading: true
    }),
    updatePromotionsComplete: (state) => ({
      ...state,
      loading: false
    }),
    getGlobalRegistrationStart: (state) => ({
      ...state,
      loading: true
    }),
    getGlobalRegistrationCompleted: (state, { payload }) => ({
      ...state,
      loading: false,
      formFields: payload
    }),
    getGlobalRegistrationFailed: (state) => ({
      ...state,
      loading: false
    }),
    updateGlobalRegistrationStart: (state) => ({
      ...state,
      loading: true
    }),
    updateGlobalRegistrationCompleted: (state) => ({
      ...state,
      loading: false
    }),
    updateGlobalRegistrationFailed: (state) => ({
      ...state,
      loading: false
    }),
    getSAUserDocumentStart: (state) => ({
      ...state,
      loading: true
    }),
    getUserDocumentSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      userDocuments: payload
    }),
    getUserDocumentFailure: (state) => ({
      ...state,
      loading: false
    }),
    verifyUserDocumentStart: (state) => ({
      ...state,
      loading: true
    }),
    verifyUserDocumentComplete: (state) => ({
      ...state,
      loading: false
    }),
    updateSACMSStatusStart: (state) => ({
      ...state,
      loading: true
    }),
    updateSACMSStatusComplete: (state) => ({
      ...state,
      loading: false
    }),
    getCMSDynamicKeysStart: (state) => ({
      ...state,
      keysLoading: true
    }),
    getCMSDynamicKeysSuccess: (state, { payload }) => ({
      ...state,
      keysLoading: false,
      cmsKeys: payload
    }),
    getCMSDynamicKeysFailure: (state) => ({
      ...state,
      keysLoading: false
    }),
    deleteCMSLanguageStart: (state) => ({
      ...state,
      loading: true
    }),
    deleteCMSLanguageComplete: (state) => ({
      ...state,
      loading: false
    }),
    updateKycMethodStart: (state) => ({
      ...state,
      kycMethodUpdateLoading: true
    }),
    updateKycMethodComplete: (state) => ({
      ...state,
      kycMethodUpdateLoading: false
    }),
    updateCountryStatusStart: (state) => ({
      ...state,
      loading: true
    }),
    updateCountryStatusComplete: (state) => ({
      ...state,
      loading: false
    }),
    getAllReviewStart: (state) => ({
      ...state,
      loading: true
    }),
    getAllReviewSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      reviewList: payload
    }),
    getAllReviewFailure: (state) => ({
      ...state,
      keysLoading: false
    }),
    updateReviewStart: (state) => ({
      ...state,
      formLoaded: true
    }),
    updateReviewSuccess: (state, { payload }) => ({
      ...state,
      formLoaded: false
    }),
    updateReviewFailure: (state) => ({
      ...state,
      formLoaded: false
    }),
    getReviewByIdStart: (state) => ({
      ...state,
      loading: true
    }),
    getReviewByIdSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      reviewDetail: payload
    }),
    getReviewByIdFailure: (state) => ({
      ...state,
      loading: false
    }),
    addReviewStart: (state) => ({
      ...state,
      formLoaded: true
    }),
    addReviewSuccess: (state, { payload }) => ({
      ...state,
      formLoaded: false
    }),
    addReviewFailure: (state) => ({
      ...state,
      loading: false
    }),
    // delete cms 
    deleteCMSStart: (state) => ({
      ...state,
      loading: true
    }),

    deleteCMSSuccess: (state, data) => {
      return {
        ...state,
        loading: false,
        error: null,
        CMSDeleteData: data?.payload,
      };
    },


    deleteCMSFailure: (state) => ({
      ...state,
      loading: false,
      CMSDeleteData: false
    }),

    deleteUserStart: (state) => ({
      ...state,
      loading: true
    }),
    deleteUserSuccess: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      userDeleteSuccess: true
    }),
    deleteUserFailure: (state) => ({
      ...state,
      loading: false,
      success: false,
      userDeleteSuccess: false
    }),

    restoreUserStart: (state) => ({
      ...state,
      loading: true
    }),
    restoreUserSuccess: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      restoreUserSuccess: true
    }),
    restoreUserFailure: (state) => ({
      ...state,
      loading: false,
      success: false,
      restoreUserSuccess: false
    }),


  }
})

export default reducer

export {
  deleteCMSStart,
  deleteCMSSuccess,
  deleteCMSFailure,
  getAllAffiliatesStart,
  getAllAffiliatesSuccess,
  getAllAffiliatesFailure,
  getAllCmsStart,
  getAllCmsSuccess,
  getAllCmsFailure,
  clearAllCms,
  getAllAvatarsSuccess,
  getAllAvatarsFailure,
  clearAllAvatars,
  getAllUsersStart,
  getAllUsersSuccess,
  getAllUsersFailure,
  getUserStart,
  getUserSuccess,
  getUserFailure,
  getAffiliateByIdStart,
  getAffiliateByIdSuccess,
  getAffiliateByIdFailure,
  getCmsByPageIdStart,
  getCmsByPageIdFailure,
  getCmsByPageIdSuccess,
  getCountriesStart,
  getCountriesSuccess,
  getCountriesFailure,
  clearAllUsers,
  getTenantCountriesStart,
  getTenantCountriesSuccess,
  getTenantCountriesFailure,
  getRestrictedItemsStart,
  getRestrictedItemsSuccess,
  getRestrictedItemsFailure,
  getUnRestrictedItemsStart,
  getUnRestrictedItemsSuccess,
  getUnRestrictedItemsFailure,
  addRestrictedItemsStart,
  addRestrictedItemsComplete,
  deleteRestrictedItemsStart,
  deleteRestrictedItemsComplete,
  resetRestrictedItemsStart,
  resetRestrictedItemsComplete,
  getRestrictedCountriesStart,
  getRestrictedCountriesSuccess,
  getRestrictedCountriesFailure,
  getUnRestrictedCountriesStart,
  getUnRestrictedCountriesSuccess,
  getUnRestrictedCountriesFailure,
  addRestrictedCountriesStart,
  addRestrictedCountriesComplete,
  deleteRestrictedCountriesStart,
  deleteRestrictedCountriesComplete,
  resetRestrictedCountriesStart,
  resetRestrictedCountriesComplete,
  updateSuperAdminCMSStart,
  updateSuperAdminCMSComplete,
  getGlobalRegistrationStart,
  getGlobalRegistrationCompleted,
  getGlobalRegistrationFailed,
  updateGlobalRegistrationStart,
  updateGlobalRegistrationCompleted,
  updateGlobalRegistrationFailed,
  getSAUserDocumentStart,
  getUserDocumentSuccess,
  getUserDocumentFailure,
  verifyUserDocumentStart,
  verifyUserDocumentComplete,
  updateSACMSStatusStart,
  updateSACMSStatusComplete,
  getCMSDynamicKeysStart,
  getCMSDynamicKeysSuccess,
  getCMSDynamicKeysFailure,
  deleteCMSLanguageStart,
  deleteCMSLanguageComplete,
  updateKycMethodStart,
  updateKycMethodComplete,
  updateCountryStatusStart,
  updateCountryStatusComplete,
  addReviewFailure,
  addReviewSuccess,
  addReviewStart,
  getReviewByIdFailure,
  getReviewByIdSuccess,
  getReviewByIdStart,
  updateReviewFailure,
  updateReviewSuccess,
  updateReviewStart,
  getAllReviewFailure,
  getAllReviewSuccess,
  getAllReviewStart,
  getAllPromotionsStart,
  getAllPromotionsSuccess,
  getAllPromotionsFailure,
  updatePromotionsStart,
  updatePromotionsComplete,
  deletePromotionsStart,
  deletePromotionsSuccess,
  deletePromotionsFailure,

  deleteUserStart,
  deleteUserSuccess,
  deleteUserFailure,

  restoreUserStart,
restoreUserSuccess,
restoreUserFailure,
}
